class PopupElement {
  constructor({
    id,
    eventType, // internal
    priority, // important, high, medium, low
    openCallback,
    closeCallback,
    position, // center, bottomLeft, bottomRight, topRight, topLeft
    name, // название попапа для определения
    templateName, // Название темплейта
    templateData, // Информация необходимая для отображения контента внутри попапа
    custom = false, // Для случаев когда попап кастомный и не имеет шаблона и информации. Он хранится в другом приложении и мы лишь подставляем его в очередь
    finishDate, // крайний срок показа
    startDate, // дата начала показа
  }) {
    this.id = id;
    this.eventType = eventType;
    this.priority = priority;
    this.openCallback = openCallback;
    this.closeCallback = closeCallback;
    this.templateData = templateData;
    this.position = position;
    this.name = name;
    this.templateName = templateName;
    this.custom = custom;
    this.finishDate = finishDate;
    this.startDate = startDate;
  }

  clearDates() {
    this.finishDate = null;
    this.startDate = null;

    if (this.templateData) {
      this.templateData.finishDate = null;
      this.templateData.startDate = null;
    }
  }
}

export default PopupElement;
